import {lighten, makeStyles} from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    swipeContainer: {
        position: "relative",
        overflow: "hidden"
    },
    parentEntityCardContainer: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        height: "4em",
        width: "100%",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        transition: "transform 0.3s ease",
        zIndex: 2,
        position: "relative",
        touchAction: "pan-y",
        color: theme.palette.common.white,
        marginTop: theme.spacing(1),
        '&.nested-1': {
            backgroundColor: theme.palette.primary.dark,
        },
        '&.nested-2': {
            backgroundColor: theme.palette.primary.dark,
        },
        '&.nested-3': {
            backgroundColor: lighten(theme.palette.primary.dark,0.05),
        },
        '&.nested-4': {
            backgroundColor: lighten(theme.palette.primary.main,0.1),
        },
        '&.nested-5': {
            backgroundColor: theme.palette.primary.light,
        },
        '&.nested-6': {
            backgroundColor: theme.palette.primary.light,
        },
    },
    hiddenContent: {
        position: "absolute",
        right: 0,
        top: 0,
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 1em",
        zIndex: 1
    },
    entityCardContainer: {
        padding: "1em 0 0 0"
    },
    entityTitle: {
        color: theme.palette.common.white
    },
    entityTitleContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center"
    },
    entityTypeIcon: {
        color: theme.palette.common.white,
    },
    ChildCountIcon: {
        width: 35,
        height: 35,
        paddingRight: theme.spacing(1)
    },
    expandIcon: {
        color: theme.palette.common.white,
        width: 15,
        height: 15,
    },
    chip: {
        width: theme.spacing(4),
        height: theme.spacing(4),
        fontSize: "smaller",
        marginRight: theme.spacing(1)
    },
    low: {
        color: theme.palette.text.primary,
    },
    medium: {
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.warning.main,
    },
    high: {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.secondary.dark
    },
    critical: {
        color: theme.palette.background.default,
        backgroundColor: theme.palette.secondary.light,
    },
}));